// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CreateRecurringDefinitionRequest } from './create-recurring-definition-request';

/** See com.rev360.pms.api.controller.schedule.scheduleitem.UpdateAppointmentSlotRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateAppointmentSlotRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Allow PHR Scheduling is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	allowPhrScheduling!: boolean;

	@GandalfProperty({ designType: Number })
	displayColor!: number | null;

	@GandalfProperty({ designType: Number })
	employeeId!: number | null;

	@GandalfValidator({ notNull: { message: 'Encounter templates is required' } })
	@GandalfArray(Number)
	encounterTemplateIds!: number[];

	@GandalfValidator({ notNull: { message: 'End Time is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	endDate!: Date;

	@GandalfValidator({ notNull: { message: 'Appointment slot ID is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	id!: number;

	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfProperty({ designType: CreateRecurringDefinitionRequest })
	recurringDefinition!: CreateRecurringDefinitionRequest | null;

	@GandalfProperty({ designType: Number })
	roleId!: number | null;

	@GandalfValidator({ notNull: { message: 'Start Time is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	startDate!: Date;

}
